import React, { useEffect, useState } from "react";

import { SeminarService } from "../../../DataService/SeminarService";
import { SeminarDto } from "../../../Types/SeminarServiceTypes";
import "../MemberDashboard.css";

export const DashboardSeminars = () => {
  const [seminars, setSeminars] = useState<SeminarDto[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadSeminars();
  }, []);

  const loadSeminars = async () => {
    try {
      const res = await SeminarService.GetMySeminars();
      setSeminars(res ?? []);
    } catch (err) {
      console.error("Seminars load error", err);
    }

    setLoading(false);
  };

  if (loading) {
    return (
      <div className="dashboard-section">
        <p>Laddar seminarier...</p>
      </div>
    );
  }

  return (
    <div className="dashboard-section">
      <div className="dashboard-header">
        <h1>Mina seminarier</h1>
        <p>Kommande seminarier du är inbjuden till.</p>
      </div>

      {seminars.length === 0 ? (
        <div className="dashboard-empty">
          <p>Inga seminarier just nu. Nya tider läggs upp löpande.</p>
        </div>
      ) : (
        <div className="dashboard-seminars-list">
          {seminars.map((seminar) => (
            <article key={seminar.id} className="dashboard-seminar-card">
              <div>
                <span className="dashboard-category">
                  {seminar.groups.map((group) => group.groupName).join(", ") || "Seminarium"}
                </span>
                <h3>{seminar.title}</h3>
                <p>{seminar.description}</p>
              </div>

              <div className="dashboard-seminar-meta">
                <strong>
                  {seminar.date} {seminar.time ? `• ${seminar.time}` : ""}
                </strong>
                {seminar.link && (
                  <a className="dashboard-download-btn" href={seminar.link} target="_blank" rel="noreferrer">
                    Öppna seminarium
                  </a>
                )}
              </div>
            </article>
          ))}
        </div>
      )}
    </div>
  );
};
